/**
 * Hook to register gift selection store reset handler with module-quote's
 * storeChangeResetRegistry.
 *
 * When the store code changes, module-quote calls all registered handlers
 * to clear cross-module state. This hook registers the flash-sale gift reset.
 *
 * USAGE:
 * Call this hook in a component that is always mounted when flash-sale is available.
 *
 * ```typescript
 * import { useFlashSaleStoreCodeChangeRegistration } from '@kidslabs/module-flash-sale';
 *
 * export const AppProviders = ({children}) => {
 *     useFlashSaleStoreCodeChangeRegistration();
 *     return <>{children}</>;
 * };
 * ```
 */

'use client';

import { useEffect } from 'react';
import { storeChangeResetRegistry } from '@kidslabs/module-quote';
import { giftSelectionStoreAPI } from '../modules/gift/stores/simple-gift-selection-store.public-api';

const MODULE_ID = 'flash-sale';

export const useFlashSaleStoreCodeChangeRegistration = (): void => {
    useEffect(() => {
        storeChangeResetRegistry.register(MODULE_ID, () => {
            giftSelectionStoreAPI.actions.resetAllSessions();
        });

        return () => {
            storeChangeResetRegistry.unregister(MODULE_ID);
        };
    }, []);
};
